import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	// create a first add node, that generates multiple points
	const add = geo.createNode('add');
	add.p.pointsCount.set(10);
	// plug it into a jitter node, to move those points around
	const jitter = geo.createNode('jitter');
	jitter.setInput(0, add);

	// and create the add node that will connect those points
	const add2 = geo.createNode('add');
	add2.setInput(0, jitter);
	add2.p.createPoint.set(false);
	add2.p.connectInputPoints.set(true);

	// let's add a material so we can actually see the line
	const materials = root.createNode('materialsNetwork');
	const lineBasic = materials.createNode('lineBasic');
	lineBasic.p.color.set([0, 0, 1]);
	// assign the material
	const material = geo.createNode('material');
	material.setInput(0, add2);
	material.p.material.setNode(lineBasic);
	material.flags.display.set(true);

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [add2],
		autoLayout: true,
	};
}
// export const sopAddCreateLine = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/add/Create Line`,
// 		createData,
// 		relatedNodes: [AddSopNode],
// 	}),
// ];
